/* tslint:disable */
/* eslint-disable */
export enum GreylistState {
  NotVerified = 'not_verified',
  Verified = 'verified',
  Critical = 'critical',
  Blocked = 'blocked'
}
